(function (app) {
    var interviewDataService;
    var nunjucks;
    var tsUsersService;
    var _modal;
    var _filter;

    var MINUTE = 60 * 1000;
    var HOUR = 60 * MINUTE;
    var DAY = 24 * HOUR;

    /**
     * Interview Scheduling V2 View Service - Draw all interview calendar related data
     * @namespace InterviewViewService
     * @param handlers
     * @constructor
     *
     * Crafted By Rami Mustaklem
     */
    var InterviewViewService = function (handlers) {
        var self = this;
        var _emitter = JarEventEmitter.call(self);

        var columnDateFormat = "ddd M/D";
        var columnDateValueFormat = "YYYY-MM-DD";
        self.columnWidth = 24 * 60 * 60 * 1000;
        self.columnsCount = 7;

        var rowDateFormat = "hh:mm a";
        var rowDateValueFormat = "HH:mm";
        self.rowHeight = 60 * 60 * 1000;
        self.rowsCount = 24;

        self.TEMPLATES = {
            CALENDAR: "../modules/interview-v2/interview-calendar-v2/calendar/views/calendar.html",
            SCHEDULE: "../modules/interview-v2/interview-calendar-v2/calendar/views/schedule.html",
            GRID: "../modules/interview-v2/interview-calendar-v2/calendar/views/grid.html",
            GRID_COLUMN: "../modules/interview-v2/interview-calendar-v2/calendar/views/grid-column.html",
            GRID_AVAILABILITY: "../modules/interview-v2/interview-calendar-v2/calendar/views/grid-availability.html",
            SLOT: "../modules/interview-v2/interview-calendar-v2/calendar/views/slot.html",
            BOOKED_SLOT: "../modules/interview-v2/interview-calendar-v2/calendar/views/booked-slot.html"
        };

        self.CONSTANTS = {
            'INTERVIEW_CONTAINER_SELECTOR': '#interview-calendar-v2',
            'EVENTS': {
                'VIEW_RENDERED': 'view_rendered'
            },
            'SLOT_WIDTH': 68,
            'COLUMN_WIDTH': 70
        };

        self.viewData = {};

        var viewSettings = {};
        viewSettings.availableSlotsPeriod = {};
        viewSettings.availableSlotsPeriod.from = moment();
        viewSettings.availableSlotsPeriod.to = moment().add(42, 'days'); // set max for period

        self.init = function (startDate, doNotBlockPastTime) {

            self.startDate = startDate;
            self.blockPastTime = !doNotBlockPastTime;


            var scheduleEndDate = moment(self.startDate).add(6, 'd');
            self.columnsSkeleton = [];
            for (var i = 0; i < self.columnsCount; i++) {
                var columnDate = moment(self.startDate).add(i, 'd');
                var columnStart = i * self.columnWidth;
                var column = {
                    start: columnStart,
                    end: columnStart + self.columnWidth,
                    date: columnDate,
                    dateLabelFormat: columnDateFormat,
                    dateValueFormat: columnDateValueFormat,
                    slots: [],
                    past: columnDate.valueOf() < moment().startOf('d').valueOf()
                };

                if (
                    interviewDataService.flatData['days'][columnDate.format(columnDateValueFormat)] &&
                    Object.keys(interviewDataService.flatData['days'][columnDate.format(columnDateValueFormat)]).length
                ) {
                    column.slots = _.toArray(interviewDataService.flatData['days'][columnDate.format(columnDateValueFormat)]);
                    self.rearrangeColumnSlots(column);
                }

                self.columnsSkeleton.push(column);
            }

            self.viewData.schedule = {};

            var schedule = {
                id: "interview-calendar-starting-" + moment(self.startDate).format(columnDateValueFormat),
                columns: angular.copy(self.columnsSkeleton),
                rows: [],
                start: self.startDate,
                end: scheduleEndDate,
                template: self.TEMPLATES.SCHEDULE
            };

            var dayHoursRows = [];
            var startOfDay = moment(self.startDate).startOf('day');
            for (var h = 0; h < 24; h++) {
                var rowTime = moment(startOfDay).add(h, 'h');
                dayHoursRows.push({
                    start: rowTime,
                    end: moment(rowTime).add(1, 'h'),
                    time: rowTime,
                    timeLabelFormat: rowDateFormat,
                    timeValueFormat: rowDateValueFormat
                });
            }

            schedule.rows = dayHoursRows;

            self.viewData.schedule = schedule;
            interviewDataService.flatData['schedules'][self.startDate.format(columnDateValueFormat)] = schedule;
        };

        self.setAvailableSlotsPeriods = function (from, to) {
            viewSettings.availableSlotsPeriod.from = moment(from);
            viewSettings.availableSlotsPeriod.to = moment(to);
        };

        self.setAvailableSlotsEndPeriods = function (interviewWindow) {
            var maxNavDate = viewSettings.availableSlotsPeriod.from.clone().add(interviewWindow, 'days').endOf('day');
            viewSettings.availableSlotsPeriod.to = moment(maxNavDate);
            self.drawAll();
        };

        self.drawAll = function () {
            var defer = $q.defer();

            var timestamp = Date.now();
            self.timestamp = timestamp;

            $(`${(self.containerParentId ? '#' + self.containerParentId : '')} ${self.CONSTANTS.INTERVIEW_CONTAINER_SELECTOR}`).empty();

            var quarterRows = [];
            for (var i = 0; i < 24; i++) {
                quarterRows.push(i);
            }

            if (!(self.viewData && self.viewData.schedule)) {
                defer.reject();
                return defer.promise;
            }

            // handlers.onLoadUsersInfo(function () {
            nunjucks.render(self.TEMPLATES.CALENDAR, {
                schedule: (self.viewData && self.viewData.schedule) || {},
                quarterRows: quarterRows,
                vStepPeriod: self.vStepPeriod,
                gridLeft: self.gridLeft,
                gridWidth: self.gridWidth,
                splitMode: !self.doNotSplit
            }, function (err, html) {
                if (timestamp === self.timestamp) {
                    if (err) {
                        console.error(err);
                    }

                    $(`${(self.containerParentId ? '#' + self.containerParentId : '')} ${self.CONSTANTS.INTERVIEW_CONTAINER_SELECTOR}`).html(html);
                    self.calculateWidths();

                    nunjucks.render("../modules/interview-v2/interview-calendar-v2/calendar/views/grid.html", {
                        schedule: self.viewData.schedule,
                        vStepPeriod: self.vStepPeriod,
                        hStepPeriod: self.hStepPeriod,
                        stepSize: self.stepSize,
                        gridLeft: self.gridLeft,
                        gridTop: self.gridTop,
                        slotWidth: self.CONSTANTS.SLOT_WIDTH,
                        columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                        employeeMode: self.employeeMode,
                        splitMode: !self.doNotSplit
                    }, function (err, html) {
                        if (err) {
                            console.error(err);
                        }

                        var grid = $(html);

                        grid.css({
                            left: self.gridLeft,
                            top: self.gridTop,
                            width: self.gridWidth,
                            height: self.gridHeight
                        });

                        $(`${(self.containerParentId ? '#' + self.containerParentId : '')} #${self.viewData.schedule.id}`).append(grid);
                        self.resetAvailabilities();
                        self.parseAvailabilities();

                        var drawNextColumn = function (index) {
                            if (self.viewData.schedule.columns[index]) {

                                for (var s in self.viewData.schedule.columns[index]['slots']) {
                                    var slot = self.viewData.schedule.columns[index]['slots'][s];
                                    if (!slot.viewInfo) {
                                        self.updateSlotViewInfo(slot);
                                    }
                                }

                                self.drawGridColumn(self.viewData.schedule, index, true, true);
                                index = index + 1;
                                drawNextColumn(index);
                            }
                            else {
                                self.drawGridAvailabilities();
                                if (self.blockPastTime) {
                                    self.blockOutRangePeriodSlots();
                                }
                                _emitter.trigger(self.CONSTANTS.EVENTS.VIEW_RENDERED);
                                self.adjustWidths();
                                self.assignListeners(self.viewData.schedule.id);
                                self.hookDragDropEvents();

                                // Scroll to first slot 8 AM
                                self.scrollToFirstSlotOrDefault();
                                defer.resolve();
                            }
                        };

                        setTimeout(function () {
                            drawNextColumn(0);
                        }, 1);

                        self.assignListeners(self.viewData.schedule.id);
                    });
                }
            });

            return defer.promise;
        };

        self.scrollToFirstSlotOrDefault = function () {
            var closetSlotTop = 0;
            $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .slots-column`).each(function () {

                var columnSlots = $(this).find($('.slot'));

                if (
                    columnSlots.length &&
                    (closetSlotTop > columnSlots.first().position().top || closetSlotTop === 0)
                ) {
                    closetSlotTop = columnSlots.first().position().top;
                }
            });

            if (!closetSlotTop) {
                closetSlotTop = 480;
            }
            else {
                closetSlotTop = parseInt(closetSlotTop / 60) * 60;

                if (closetSlotTop > 60) {
                    closetSlotTop -= 60;
                }
            }

            $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview_schedule_v2`).scrollTop(closetSlotTop);
        };

        self.drawGridColumn = function (schedule, columnIndex, isNew, noAvailabilities) {
            var defer = $q.defer();
            columnIndex = parseInt(columnIndex);
            var column = schedule['columns'][columnIndex];

            var html = nunjucks.render(self.TEMPLATES.GRID_COLUMN, {
                column: column,
                vStepPeriod: self.vStepPeriod,
                hStepPeriod: self.hStepPeriod,
                stepSize: self.stepSize,
                gridLeft: self.gridLeft,
                gridTop: self.gridTop,
                slotWidth: self.CONSTANTS.SLOT_WIDTH,
                columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                employeeMode: self.employeeMode,
                splitMode: !self.doNotSplit
            });

            var columnElm = $(html);

            if (isNew) {
                if (columnIndex === 0) {
                    $(`${(self.containerParentId ? '#' + self.containerParentId : '')} ${self.CONSTANTS.INTERVIEW_CONTAINER_SELECTOR} #${schedule.id} .grid`).prepend(columnElm);
                }
                else {
                    $(`${(self.containerParentId ? '#' + self.containerParentId : '')} ${self.CONSTANTS.INTERVIEW_CONTAINER_SELECTOR} #${schedule.id} .item:eq(${columnIndex - 1})`).after(columnElm);
                }
            }
            else {
                $(`${(self.containerParentId ? '#' + self.containerParentId : '')} ${self.CONSTANTS.INTERVIEW_CONTAINER_SELECTOR} #${schedule.id} .item:eq(${columnIndex})`).replaceWith(columnElm);
            }

            if (!noAvailabilities) {
                setTimeout(function () {
                    self.drawGridAvailabilities(columnIndex);
                    defer.resolve(columnElm);
                }, 10);
            }
            else {
                defer.resolve(columnElm);
            }

            return defer.promise;
        };

        self.calculateWidths = function () {
            let scheduleTable = $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .schedule-table`);
            var columnWidth = scheduleTable.find(".col-info").first().outerWidth();
            var rowHeight = scheduleTable.find(".col-info").first().outerHeight();

            try {
                if (scheduleTable.find(".col-info")[0]) {
                    rowHeight = scheduleTable.find(".col-info")[0].getBoundingClientRect().height;
                }
            }
            catch (e) {
                console.error(e);
            }

            self.gridTop = 0;
            self.gridWidth = $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview-schedule`).width() - columnWidth;
            self.gridLeft = columnWidth;


            self.gridHeight = rowHeight * self.rowsCount;
            self.vStepPeriod = rowHeight; // must be row height - each row is a vertical step
            self.hStepPeriod = columnWidth; // must be column width - each column is a horizontal step
            self.CONSTANTS.SLOT_WIDTH = columnWidth;
            self.CONSTANTS.COLUMN_WIDTH = columnWidth;

            // stepSize by default must be quarter of an hour in row height (60px * 0.25) = 15px -> 15 minutes
            // vStepPeriod is the height of the row (hour) which is 60px -> 60 minutes
            self.stepSize = self.stepSize || (self.vStepPeriod * 0.25);
        };

        self.adjustWidths = function () {
            $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview_schedule_v2_header`).width($(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview-schedule`).width());
        };

        self.createNewSlot = function (scheduleId, columnIndex, action) {

            return {
                id: "temp_" + Date.now(),
                viewInfo: {
                    id: 'NEW',
                    column: parseInt(columnIndex),
                    offset: action['elmStartY'] / self.stepSize,
                    height: 1
                }
            };
        };

        self.clearSlots = function () {

            if (!self.viewData.schedule) {
                return;
            }

            var currentTime = moment().valueOf();
            for (var c in self.viewData.schedule.columns) {

                var slotsArray = self.viewData.schedule.columns[c].slots;
                var slotsArrayLength = slotsArray.length;

                for (var s = slotsArrayLength - 1; s >= 0; s--) {
                    var slot = slotsArray[s];

                    if (slot.start_time > currentTime) {
                        slotsArray.splice(s, 1);
                    }
                }
            }
        };

        self.getSlotHTML = function (scheduleId, columnIndex, slot) {
            var schedule = self.viewData.schedule;
            var column = schedule['columns'][columnIndex];

            return nunjucks.render("../modules/interview-v2/interview-calendar-v2/calendar/views/slot.html", {
                slot: slot,
                column: column,
                vStepPeriod: self.vStepPeriod,
                hStepPeriod: self.hStepPeriod,
                stepSize: self.stepSize,
                gridLeft: self.gridLeft,
                gridTop: self.gridTop,
                slotWidth: self.CONSTANTS.SLOT_WIDTH,
                columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                employeeMode: self.employeeMode,
                splitMode: !self.doNotSplit
            });
        };

        self.updateSlotTime = function (slot) {
            var dayReferenceStart = moment(self.startDate).startOf('day').valueOf();
            slot.day = dayReferenceStart + (slot.viewInfo.column * DAY);
            slot.start_time = slot.day + (slot.viewInfo.offset / (self.vStepPeriod / self.stepSize) * HOUR);
            slot.end_time = slot.day + ((slot.viewInfo.offset + slot.viewInfo.height) / (self.vStepPeriod / self.stepSize) * HOUR);
        };

        self.isAllowed = function (from, to, action) {

            if (!self.employeeMode) {
                return true; // Allowed
            }
        };

        self.moveSlot = function (action, from, to, doCopy) {

            var schedule = self.viewData.schedule;
            var fromColumn = schedule.columns[from.columnIndex];
            var toColumn = schedule.columns[to.columnIndex];
            var slotInAction = doCopy? angular.copy(fromColumn.slots[from.slotIndex]): fromColumn.slots[from.slotIndex];
            var tempId = "temp_" + Date.now();
            // to remove old calendar restrictions the move will always be at the minimum step size of 15 minutes
            var moveStepSize = 15;

            // Add a temp id for slot, in case copy (new slot is actually being created)
            if (doCopy) {
                slotInAction.id = tempId;
            }

            var originalSlot = $.extend({}, slotInAction);

            slotInAction.viewInfo.column += action.stepsX;
            slotInAction.viewInfo.offset += action.stepsY;
            slotInAction.day += (action.stepsX * DAY);
            slotInAction.start_time += (action.stepsY / (self.vStepPeriod / moveStepSize) * HOUR) + (action.stepsX * DAY);
            slotInAction.end_time += (action.stepsY / (self.vStepPeriod / moveStepSize) * HOUR) + (action.stepsX * DAY);

            self.fixSlotTimeDifferiation(slotInAction);

            var overlapInfo = self.doesSlotOverlapWithBooked(slotInAction);

            var splitSlots = overlapInfo.slots;
            if (overlapInfo.doOverlap) {
                slotInAction = originalSlot;
                self.updateViewData(toColumn, slotInAction.id, slotInAction);
                if (from.columnIndex != to.columnIndex) {
                    self.updateViewData(fromColumn, slotInAction.id, null);
                }
                return;
            }

            if (!self.doNotSplit) {
                for (var i in toColumn.slots) {
                    if (slotInAction.id != toColumn.slots[i].id && self.doOverlap(slotInAction, toColumn.slots[i])) {
                        slotInAction = originalSlot;
                        self.updateViewData(toColumn, slotInAction.id, slotInAction);
                        if (from.columnIndex != to.columnIndex) {
                            self.updateViewData(fromColumn, slotInAction.id, null);
                        }
                        return;
                    }
                }
            }

            fromColumn.slots.splice(from.slotIndex, 1);
            interviewDataService.deleteSlot(originalSlot);

            for (var i in splitSlots) {
                var splitSlot = splitSlots[i];

                if (splitSlot.viewInfo.height) {
                    var slotSteps;
                    if (!self.doNotSplit) {
                        slotSteps = self.splitSlotsToSteps(splitSlot);

                        for (var n in slotSteps) {
                            var newStepSlot = slotSteps[n];
                            self.updateSlotViewInfo(newStepSlot);
                            interviewDataService.addSlot(newStepSlot);
                            self.updateViewData(fromColumn, slotInAction.id, newStepSlot);
                        }
                    }
                    else {
                        self.updateSlotViewInfo(splitSlot);
                        interviewDataService.addSlot(splitSlot);
                        self.updateViewData(fromColumn, slotInAction.id, splitSlot);
                    }
                }
            }

            handlers.onMoved && handlers.onMoved(splitSlots, toColumn, doCopy);
        };

        self.resizeSlot = function (action, from, offsetShift, sizeChange) {
            var schedule = self.viewData.schedule;
            var fromColumn = schedule.columns[from.columnIndex];
            var slotInAction = fromColumn.slots[from.slotIndex];

            if (offsetShift) {
                slotInAction.viewInfo.offset += offsetShift;
                slotInAction.viewInfo.height -= offsetShift;
                slotInAction.start_time += (offsetShift / (self.vStepPeriod / self.stepSize) * HOUR);
            }

            if (sizeChange) {
                slotInAction.viewInfo.height += sizeChange;
                slotInAction.end_time += (sizeChange / (self.vStepPeriod / self.stepSize) * HOUR);
            }

            var overlapInfo = self.doesSlotOverlapWithBooked(slotInAction);
            var splitSlots = overlapInfo.slots;
            fromColumn.slots.splice(from.slotIndex, 1);
            interviewDataService.deleteSlot(slotInAction);

            for (var i in splitSlots) {
                var splitSlot = splitSlots[i];

                if (splitSlot.viewInfo.height) {
                    var slotSteps;
                    if (!self.doNotSplit) {
                        slotSteps = self.splitSlotsToSteps(splitSlot);

                        for (var n in slotSteps) {
                            var newStepSlot = slotSteps[n];
                            self.updateSlotViewInfo(newStepSlot);
                            interviewDataService.addSlot(newStepSlot);
                            self.updateViewData(fromColumn, slotInAction.id, newStepSlot);
                        }
                    }
                    else {
                        self.updateSlotViewInfo(splitSlot);
                        interviewDataService.addSlot(splitSlot);
                        self.updateViewData(fromColumn, slotInAction.id, splitSlot);
                    }
                }
            }

            handlers.onResized && handlers.onResized(splitSlots);
        };

        self.createSlot = function (action, from, offset, height) {
            var schedule = self.viewData.schedule;
            var fromColumn = schedule.columns[from.columnIndex];
            var slotInAction = self.createNewSlot(schedule.id, from.columnIndex, action);

            slotInAction['viewInfo'] = {
                offset: offset,
                height: height,
                column: from.columnIndex
            };

            // get the slot top and left offsets to determine when is the start time of the slot
            // horizontal offset will be the which (DAY) and vertical offset will be which (TIME)
            var slotDay = moment(self.startDate).startOf('day').add(from.columnIndex, 'd').valueOf();
            slotInAction.start_time = slotDay + (offset / (self.vStepPeriod / self.stepSize) * HOUR);
            slotInAction.end_time = slotDay + ((offset + height) / (self.vStepPeriod / self.stepSize) * HOUR);
            slotInAction.day = slotDay;

            // I want to check if this new slot overlaps a booked availability slot
            var overlapInfo = self.doesSlotOverlapWithBooked(slotInAction);
            var splitSlots = overlapInfo.slots;

            for (var i in splitSlots) {
                var splitSlot = splitSlots[i];

                if (splitSlot.viewInfo.height) {
                    if (!self.doNotSplit) {
                        var slotSteps = self.splitSlotsToSteps(splitSlot);

                        for (var n in slotSteps) {
                            var newStepSlot = slotSteps[n];
                            var doAdd = true;

                            self.fixSlotTimeDifferiation(newStepSlot);

                            for (var j in fromColumn.slots) {
                                if (self.doOverlap(newStepSlot, fromColumn.slots[j])) {
                                    doAdd = false;
                                    break;
                                }
                            }

                            if (doAdd) {
                                self.updateSlotViewInfo(newStepSlot);
                                interviewDataService.addSlot(newStepSlot);
                                self.updateViewData(fromColumn, null, newStepSlot);
                            }
                        }
                    }
                    else {
                        self.updateSlotViewInfo(splitSlot);
                        interviewDataService.addSlot(splitSlot);
                        self.updateViewData(fromColumn, null, splitSlot);
                    }
                }
            }

            handlers.onCreated && handlers.onCreated(splitSlots);
        };

        self.splitSlotsToSteps = function (slot) {
            var slotPeriod = slot.end_time - slot.start_time;
            var steps = slotPeriod / (self.stepSize * MINUTE);
            var stepSlots = [];

            for (var i = 0; i < steps; i++) {
                stepSlots.push({
                    day: slot.day,
                    id: "temp_" + i + "_" + Date.now(),
                    start_time: slot.start_time + (i * self.stepSize * MINUTE),
                    end_time: slot.start_time + ((i + 1) * self.stepSize * MINUTE)
                });
            }

            return stepSlots;
        };

        self.doesSlotOverlapWithBooked = function (slotInAction) {
            var splitSlots = [];
            var overlaps = false;

            for (var s in self.viewData['availabilities']) {
                var availability = self.viewData['availabilities'][s];
                if (
                    availability.type === 'BOOKED' &&
                    availability.viewInfo.column === slotInAction.viewInfo.column &&
                    self.doOverlap(slotInAction, availability)
                ) {
                    overlaps = true;

                    if (
                        slotInAction.start_time < availability.start_time &&
                        slotInAction.end_time < availability.end_time
                    ) {
                        slotInAction.end_time = availability.start_time;

                        splitSlots = [slotInAction];
                    }
                    if (
                        slotInAction.start_time > availability.start_time &&
                        slotInAction.end_time > availability.end_time
                    ) {
                        slotInAction.start_time = availability.end_time;

                        splitSlots = [slotInAction];
                    }
                    // if the slotInAction covers the availability top to bottom I will split it
                    if (
                        slotInAction.start_time < availability.start_time &&
                        slotInAction.end_time > availability.end_time
                    ) {
                        var firstSlot = $.extend({}, slotInAction);
                        firstSlot.end_time = availability.start_time;
                        firstSlot.id = "temp_first_" + Date.now();

                        var secondSlot = $.extend({}, slotInAction);
                        secondSlot.start_time = availability.end_time;
                        secondSlot.id = "temp_second_" + Date.now();

                        splitSlots = [firstSlot, secondSlot];
                    }
                }
            }

            if (!overlaps) {
                splitSlots = [slotInAction];
            }

            return {
                slots: splitSlots,
                doOverlap: overlaps
            };
        };

        self.rearrangeColumnSlots = function (columnObj) {
            var tempColumn = { slots: [] };
            tempColumn.slots = _.sortBy(columnObj.slots, 'start_time');
            columnObj.slots = tempColumn.slots;
        };

        self.addSlotToColumn = function (column, slot) {
            if (column.slots) {
                if (column.slots.length > 0) {
                    self.fixSlotTimeDifferiation(slot);
                    column.slots.push(slot);
                    let newSlotIndex = column.slots.findIndex(value => value.id === slot.id);
                    var columnSlotsCopy = angular.copy(column.slots);
                    columnSlotsCopy.forEach(function (oldSlot) {
                        if (column.slots[newSlotIndex]['id'] !== oldSlot['id'] && self.doOverlap(column.slots[newSlotIndex], oldSlot)) {
                            newSlotIndex = self.mergeOverlappingSlots(column.slots[newSlotIndex], oldSlot, column);
                        }
                    });
                }
                else if (column.slots.length === 0) {
                    column.slots.push(slot);
                }
            }
            else {
                column.slots = [slot];
            }
        };

        /**
         * If two slots in a column overlap each other in any way
         * @method InterviewViewService#doOverlap
         * @param slot1 - New Slot
         * @param slot2 - Old Slot
         * @return {boolean}
         */
        self.doOverlap = function (slot1, slot2) {
            var slot1Start = Math.round(slot1.start_time / (HOUR * 0.25)) * HOUR * 0.25,
                slot2Start = Math.round(slot2.start_time / (HOUR * 0.25)) * HOUR * 0.25,
                slot1End = Math.round(slot1.end_time / (HOUR * 0.25)) * HOUR * 0.25,
                slot2End = Math.round(slot2.end_time / (HOUR * 0.25)) * HOUR * 0.25;

            if (
                (slot1Start < slot2Start && slot1End <= slot2Start) ||
                (slot1End > slot2End && slot1Start >= slot2End)
            ) {
                return false;
            }

            return true;
        };

        /**
         * If slots overlap each other in any way merge them and give me one final slot
         * @method InterviewViewService#mergeOverlappingSlots
         * @param slot1 - New Slot
         * @param slot2 - Old Slot
         * @param column - Where slots are being manipulated
         */
        self.mergeOverlappingSlots = function (slot1, slot2, column) {
            var slot1Start = slot1.start_time,
                slot2Start = slot2.start_time,
                slot1End = slot1.end_time,
                slot2End = slot2.end_time,
                newSlotStart, newSlotEnd,
                slot1Index = _.findIndex(column.slots, function (value) {
                    return value.id == slot1.id;
                }),
                slot2Index = _.findIndex(column.slots, function (value) {
                    return value.id == slot2.id;
                });

            var slotDay = slot2.day;
            var slotColumn = slot2.viewInfo.column;

            if ( (slot1Start >  slot2Start) && (slot1End <  slot2End) ) {
                newSlotStart = slot2Start;
                newSlotEnd = slot2End;
            } else if ( (slot1End >=  slot2End ) && (slot1Start <=  slot2Start) ) {
                newSlotStart = slot1Start;
                newSlotEnd = slot1End;
            } else if ( (slot1Start >  slot2Start ) && (slot1Start <  slot2End) ) {
                newSlotStart = slot2Start;
                newSlotEnd = slot1End;
            } else if ( (slot1End >  slot2Start ) && (slot1End <  slot2End) ) {
                newSlotStart = slot1Start;
                newSlotEnd = slot2End;
            }

            var newSlot = {
                id: "temp_" + Date.now(),
                start_time: newSlotStart,
                end_time: newSlotEnd,
                day: slotDay,
                viewInfo: {
                    id: 'NEW',
                    column: slotColumn,
                    height: (newSlotEnd - newSlotStart) / HOUR * (self.vStepPeriod / self.stepSize),
                    offset: (newSlotStart - slotDay) / HOUR * (self.vStepPeriod / self.stepSize)
                }
            };

            if (slot1Index > -1) column.slots.splice(slot1Index, 1);
            if (slot2Index > -1) column.slots.splice(slot2Index, 1);
            interviewDataService.deleteSlot(slot1);
            interviewDataService.deleteSlot(slot2);
            var newSlotIndex = column.slots.push(newSlot) - 1;
            interviewDataService.addSlot(newSlot);
            return newSlotIndex;
        };

        self.updateViewData = function (fromColumn, slotId, updatedResponse, flashSlot) {
            var drawPromises = [];

            var originalColumnIndex = self.viewData.schedule.columns.indexOf(fromColumn);

            if (originalColumnIndex && slotId) {
                // Remove the slot from its original place
                var slotIndex = _.findIndex(fromColumn.slots, {id: slotId});

                if (slotIndex > -1) {
                    self.viewData.schedule.columns[originalColumnIndex]['slots'].splice(slotIndex, 1);
                }

                self.rearrangeColumnSlots(self.viewData.schedule.columns[originalColumnIndex]);
                drawPromises.push(self.drawGridColumn(self.viewData.schedule, originalColumnIndex));
            }

            if (updatedResponse) {
                var slot = updatedResponse;
                self.updateSlotViewInfo(slot);
                self.rearrangeColumnSlots(self.viewData.schedule.columns[slot.viewInfo.column]);
                self.addSlotToColumn(self.viewData.schedule.columns[slot.viewInfo.column], slot);
                drawPromises.push(self.drawGridColumn(self.viewData.schedule, slot.viewInfo.column));
            }

            $q.all(drawPromises)
                .then(function () {

                    if (self.viewData.schedule) {
                        self.assignListeners(self.viewData.schedule.id);
                    }

                    if (flashSlot) {
                        self.flashElm($(`${(self.containerParentId ? '#' + self.containerParentId : '')} .slot#${slot.id}`));
                    }
                });
        };

        // Fix any issue in start/end time of a slot that cause start time and end time
        // to have partial steps e.g. step period: 15.134 Minutes => 15 Minutes
        self.fixSlotTimeDifferiation = function (slot) {

            // Slot without type is a normal interview slot
            // Other slot types are booked and availability
            if (!slot.type && !slot.past) {
                var stepSizeInMillis = self.stepSize * 60 * 1000;
                var minStepSizeInMillis = 15 * 60 * 1000;
                var startInSteps = Math.round(slot.start_time / minStepSizeInMillis);
                var endInSteps = Math.round(slot.end_time / minStepSizeInMillis);

                slot.start_time = minStepSizeInMillis * startInSteps;
                slot.end_time = minStepSizeInMillis * endInSteps;

                if (!self.doNotSplit) {
                    var durationInSteps = parseInt((slot.end_time - slot.start_time) / stepSizeInMillis);
                    if (durationInSteps < 1) {
                        durationInSteps = 1;
                    }

                    slot.end_time = slot.start_time + (durationInSteps * stepSizeInMillis);
                }
            }

        };

        self.updateSlotViewInfo = function (slot) {

            var slotOffset, slotColumn, slotHeight;
            var dayReferenceStart = moment(slot.start_time).startOf('day').valueOf();

            self.fixSlotTimeDifferiation(slot);

            // height means how many hours a slot spans - period of slot in ms / hour in ms * 60px height of row
            slotHeight = ((slot.end_time - slot.start_time) / HOUR) * (self.vStepPeriod / self.stepSize); // in the view (this * self.vStepPeriod)
            // offset means in which row (hour) of that column (day) - row index / hour in ms * 60px height of row (top attribute) + grid top
            slotOffset = ((slot.start_time - dayReferenceStart) / HOUR) * (self.vStepPeriod / self.stepSize); // in the view (this * self.vStepPeriod)
            // column means in which column (day) - column index
            slotColumn = Math.round((dayReferenceStart - moment(self.startDate.startOf('day')).valueOf()) / DAY);

            slot.viewInfo = {
                offset: slotOffset,
                height: slotHeight,
                column: Math.abs(slotColumn)
            };
        };

        self.resetAvailabilities = function () {
            self.viewData['availabilities'] = [];
        };

        self.parseAvailabilities = function () {
            self.viewData['availabilities'] = self.viewData['availabilities'] || [];

            for (var d in interviewDataService.availabitlies) {
                var day = interviewDataService.availabitlies[d];

                for (var avail in day) {
                    var availability = day[avail];

                    // In case of AVAILABLE slots we want the intersected ones
                    // If the ids array is more than 1 that means it's a merged (with intersection) slot
                    if (availability.type === 'AVAILABLE' && availability.ids.length < 2 && !availability.force) {
                        continue;
                    }

                    self.updateSlotViewInfo(availability);
                    self.viewData['availabilities'].push(availability);
                }
            }
        };

        self.clearGridAvailabilities = function () {
            $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview-schedule`).find(".availability_interval").remove();
        };

        self.drawGridAvailabilities = function (columnIndex) {
            for (var avail in self.viewData['availabilities']) {
                var availability = self.viewData['availabilities'][avail];

                if (!columnIndex || columnIndex === availability.viewInfo.column) {
                    var targetIndex = availability.viewInfo.column;
                    let targetColumn = $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .item.slots-column`).get(targetIndex);
                    // $(targetColumn).find(".availability_interval").remove();

                    var html = nunjucks.render(self.TEMPLATES.GRID_AVAILABILITY, {
                        availability: availability,
                        stepSize: self.stepSize,
                        slotWidth: self.CONSTANTS.SLOT_WIDTH,
                        users: interviewDataService.flatData['interviewers'],
                        columnIndex: targetIndex,
                        columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                        gridLeft: self.gridLeft,
                        gridTop: self.gridTop,
                        employeeMode: self.employeeMode,
                        splitMode: !self.doNotSplit
                    });

                    $(targetColumn).parents(".interview-schedule").append(html);

                    if (availability.type === 'BOOKED') {

                        var slotBlocker = nunjucks.render(self.TEMPLATES.BOOKED_SLOT, {
                            availability: availability,
                            stepSize: self.stepSize,
                            slotWidth: self.CONSTANTS.SLOT_WIDTH,
                            columnIndex: targetIndex,
                            columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                            gridLeft: self.gridLeft,
                            gridTop: self.gridTop,
                            employeeMode: self.employeeMode,
                            splitMode: !self.doNotSplit
                        });

                        $(targetColumn).parents(".interview-schedule").append(slotBlocker);

                    }
                }
            }
        };

        self.blockOutRangePeriodSlots = function () {
            for (var day in self.viewData.schedule.columns) {
                var column = self.viewData.schedule.columns[day];

                if (
                    moment(column.date).isSameOrBefore(viewSettings.availableSlotsPeriod.from, 'day')
                    || moment(column.date).isSameOrAfter(viewSettings.availableSlotsPeriod.to, 'day')
                ) {
                    var fromIsSameDay = moment(column.date).isSame(viewSettings.availableSlotsPeriod.from, 'day');
                    var toIsSameDay = moment(column.date).isSame(viewSettings.availableSlotsPeriod.to, 'day');
                    var columnDay = moment(column.date).startOf('day').valueOf();
                    var blockedPeriods = [];

                    if (fromIsSameDay || toIsSameDay) {
                        if (fromIsSameDay) {
                            var row = self.viewData.schedule.rows[0];
                            var rowHourStart = moment((day * DAY) + row.start).valueOf();
                            var rowHourQuarterEnd = Math.ceil(viewSettings.availableSlotsPeriod.from.valueOf() / (15 * MINUTE)) * 15 * MINUTE;

                            blockedPeriods.push({
                                start_time: rowHourStart,
                                end_time: rowHourQuarterEnd,
                                day: columnDay + (day * DAY),
                                past: true
                            });

                        }

                        if (toIsSameDay) {
                            var row = self.viewData.schedule.rows[self.viewData.schedule.rows.length - 1];
                            var rowHourQuarterStart = Math.floor(viewSettings.availableSlotsPeriod.to.valueOf() / (15 * MINUTE)) * 15 * MINUTE;
                            var rowHourEnd = moment((day * DAY) + row.end).valueOf();

                            blockedPeriods.push({
                                start_time: rowHourQuarterStart,
                                end_time: rowHourEnd,
                                day: columnDay + (day * DAY),
                                past: true
                            });
                        }
                    }
                    else {
                        blockedPeriods.push({
                            start_time: columnDay,
                            end_time: moment(columnDay).endOf('day').valueOf(),
                            day: columnDay,
                            past: true,
                            wholeDay: true
                        });
                    }

                    for (var i in blockedPeriods) {

                        var blockedPeriod = blockedPeriods[i];
                        if (!blockedPeriod.viewInfo) {
                            self.updateSlotViewInfo(blockedPeriod);
                        }

                        var blockerElm = nunjucks.render(self.TEMPLATES.BOOKED_SLOT, {
                            availability: blockedPeriod,
                            stepSize: self.stepSize,
                            slotWidth: self.CONSTANTS.SLOT_WIDTH,
                            columnIndex: parseInt(day),
                            columnWidth: self.CONSTANTS.COLUMN_WIDTH,
                            gridLeft: self.gridLeft,
                            gridTop: self.gridTop,
                            employeeMode: self.employeeMode,
                            splitMode: !self.doNotSplit
                        });

                        $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview-schedule`).append(blockerElm);
                    }
                }
            }
        };

        self.assignListeners = function (scheduleId) {
            var viewOnly = self.employeeMode;

            if (viewOnly) {
                $(`${(self.containerParentId ? '#' + self.containerParentId : '')} .interview-schedule.the-schedule`).addClass("view-only");
            }

            self.interviewDragDropService.assignListeners(scheduleId, viewOnly);
        };

        var resizeTimeout;

        $(window)
            .off("resize.schedule")
            .on("resize.schedule", function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    self.drawAll()
                        .then(function () {
                        });
                }, 200);
            });

        self.flashElm = function (elm, speed) {
            speed = speed || 60;
            elm.stop().fadeOut(speed).fadeIn(speed);
        };

        self.destroy = function () {
            self.interviewDragDropService.offAll();
            self.offAll();
            self.timestamp = null;
            $(window).off("resize.schedule");
            self.viewData = {};
        };

        self.initDragDropService = function (dragDropService) {
            self.interviewDragDropService = dragDropService(self);
        };

        self.hookDragDropEvents = function () {
            self.interviewDragDropService.offAll();

            var getOverlapSlot = function (slotInAction, fromColumn) {
                var startTimeOverlapped, endTimeOverlapped;
                for (var i in fromColumn.slots) {
                    if (slotInAction.id != fromColumn.slots[i].id && self.doOverlap(slotInAction, fromColumn.slots[i])) {
                        if (slotInAction.end_time == fromColumn.slots[i].end_time && slotInAction.start_time == fromColumn.slots[i].start_time) {
                            startTimeOverlapped = fromColumn.slots[i].start_time;
                            startTimeOverlapped =  fromColumn.slots[i].end_time;
                        }

                        if (slotInAction.end_time > fromColumn.slots[i].start_time) {
                            endTimeOverlapped = fromColumn.slots[i].start_time;
                        }

                        if (slotInAction.start_time < fromColumn.slots[i].end_time) {
                            startTimeOverlapped = fromColumn.slots[i].end_time;
                        }

                        if (startTimeOverlapped && endTimeOverlapped) {
                            return fromColumn.slots[i].start_time;
                        }
                    }
                }
                return -1;
            }

            var getOverlapAvailability = function (slotInAction) {
                for (var a in self.viewData.availabilities) {
                    if (self.viewData.availabilities[a]['type'] === 'BOOKED') {
                        if (self.doOverlap(self.viewData.availabilities[a], slotInAction)) {
                            return self.viewData.availabilities[a].start_time;
                        }
                    }
                }
                return -1;
            };

            var updateSlotTimeUsingOffset = function (slotInAction) {
                slotInAction.start_time = slotInAction.day + (slotInAction.viewInfo.offset / (self.vStepPeriod / self.stepSize) * HOUR);
                slotInAction.end_time = slotInAction.day + ((slotInAction.viewInfo.offset + slotInAction.viewInfo.height) / (self.vStepPeriod / self.stepSize) * HOUR);
            };

            var handleOverlap = function (getOffsetFunction, slotInAction, overlapStartTime, fromColumn) {
                var offsetDifference = ((slotInAction.end_time - overlapStartTime) / HOUR) * (self.vStepPeriod / self.stepSize);
                if (offsetDifference > -1) {
                    slotInAction.viewInfo.offset -= offsetDifference;
                    if (slotInAction.viewInfo.offset < 0) {return false;}
                    updateSlotTimeUsingOffset(slotInAction);
                    if (getOffsetFunction(slotInAction, fromColumn) > -1) {return false;}
                } else {
                    return false;
                }
                return true;
            };

            self.interviewDragDropService.on('column_clicked', function (action) {
                var schedule = self.viewData.schedule;
                var fromColumn = schedule.columns[action['columnIndex']];
                var slotInAction = self.createNewSlot(schedule.id, action['columnIndex'], action);
                slotInAction.day = moment(self.startDate).startOf('day').add(action['columnIndex'], 'd').valueOf();
                updateSlotTimeUsingOffset(slotInAction);

                //handle if overlap with availabilites
                var overlapStartTime, overlapHandled;
                overlapStartTime = getOverlapAvailability(slotInAction);
                if (overlapStartTime > -1) {
                    overlapHandled = handleOverlap(getOverlapAvailability, slotInAction, overlapStartTime, fromColumn);
                    if (!overlapHandled) {return;}
                }

                //handle if overlap with any slot in the same column
                if (!self.doNotSplit) {
                    overlapStartTime = getOverlapSlot(slotInAction, fromColumn);
                    if (overlapStartTime > -1) {
                        overlapHandled = handleOverlap(getOverlapSlot, slotInAction, overlapStartTime, fromColumn);
                        if (!overlapHandled) {return;}
                    }
                }

                interviewDataService.addSlot(slotInAction);
                self.updateViewData(fromColumn, null, slotInAction);

                handlers.onCreated && handlers.onCreated(slotInAction);
            });

            self.interviewDragDropService.on('clicked', function (action) {
                var schedule = self.viewData.schedule;
                var fromColumn = schedule.columns[action['columnIndex']];
                var slotInAction = fromColumn.slots[action['slotIndex']];

                if (self.employeeMode) {
                    handlers.onClick && handlers.onClick(slotInAction);
                }
                else {
                    interviewDataService.deleteSlot(slotInAction);
                    fromColumn.slots.splice(action['slotIndex'], 1);
                    self.drawGridColumn(self.viewData.schedule, action['columnIndex'])
                        .then(function () {
                            self.assignListeners(self.viewData.schedule.id);
                        });
                }
            });
        };
    };

    app.service('InterviewViewService', [
        'InterviewDragDropService', 'InterviewDataService', 'DispatcherServices', 'TSUsersService', '$filter', '$modal',
        function (InterviewDragDropService, InterviewDataService, DispatcherServices, TSUsersService, $filter, $modal) {
            nunjucks = DispatcherServices.getNunjucks();
            interviewDataService = InterviewDataService;
            tsUsersService = TSUsersService;
            _filter = $filter;
            _modal = $modal;

            return function (handlers) {
                var service = new InterviewViewService(handlers);
                service.initDragDropService(InterviewDragDropService);
                return service;
            }
        }
    ]);

})(angular.module('harriApp.interviewV2'));